export interface FilterItemInterface {
  id?: number;
  name?: string;
  isSelected?: boolean;
}

export class FilterItem implements FilterItemInterface {
  public id?: number;
  public name?: string;
  public isSelected?: boolean;

  constructor({
    id = undefined,
    name = undefined,
    isSelected = undefined,
  }: FilterItemInterface) {
    this.id = id;
    this.name = name;
    this.isSelected = isSelected;
  }
}
